<template>
  <main class="mall_main w-full">
    <div class="pt-5">
      <div
        class="w-fit flex justify-center items-center bg-slate-100 rounded-full mx-auto px-4 py-1 text-sm sticky top-1"
      >
        {{ todayDate }}
      </div>
      <div class="w-full my-5 p-5">
        <div>
          <svg
            width="51"
            height="51"
            viewBox="0 0 51 51"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M25.4958 0.5C21.1585 0.498539 16.8954 1.62552 13.1255 3.7702C9.35555 5.91488 6.20845 9.00347 3.99339 12.7325C1.77834 16.4615 0.571559 20.7027 0.491621 25.0392C0.411682 29.3758 1.46134 33.6585 3.53745 37.4667L0.579124 47.8417C0.475029 48.206 0.472256 48.5918 0.571103 48.9575C0.66995 49.3233 0.866674 49.6552 1.1401 49.9175C1.41353 50.1798 1.75331 50.3625 2.12287 50.4461C2.49244 50.5296 2.87779 50.5108 3.23745 50.3917L12.9791 47.1458C16.2994 49.0645 20.0165 50.1936 23.8429 50.4458C27.6693 50.6981 31.5025 50.0667 35.0459 48.6005C38.5893 47.1344 41.7479 44.8727 44.2774 41.9905C46.8068 39.1083 48.6394 35.6829 49.6332 31.9791C50.627 28.2754 50.7555 24.3927 50.0087 20.6314C49.2619 16.8701 47.6599 13.331 45.3265 10.2878C42.9931 7.24472 39.9909 4.77918 36.5522 3.08195C33.1135 1.38471 29.3305 0.501281 25.4958 0.5Z"
              fill="url(#paint0_linear_54_4)"
            />
            <path
              d="M17.1624 21.3333C17.1624 20.7808 17.3819 20.2509 17.7726 19.8602C18.1633 19.4695 18.6932 19.25 19.2458 19.25H31.7458C32.2983 19.25 32.8282 19.4695 33.2189 19.8602C33.6096 20.2509 33.8291 20.7808 33.8291 21.3333C33.8291 21.8859 33.6096 22.4158 33.2189 22.8065C32.8282 23.1972 32.2983 23.4167 31.7458 23.4167H19.2458C18.6932 23.4167 18.1633 23.1972 17.7726 22.8065C17.3819 22.4158 17.1624 21.8859 17.1624 21.3333ZM19.2458 27.5833H27.5791C28.1316 27.5833 28.6615 27.8028 29.0522 28.1935C29.4429 28.5842 29.6624 29.1141 29.6624 29.6667C29.6624 30.2192 29.4429 30.7491 29.0522 31.1398C28.6615 31.5305 28.1316 31.75 27.5791 31.75H19.2458C18.6932 31.75 18.1633 31.5305 17.7726 31.1398C17.3819 30.7491 17.1624 30.2192 17.1624 29.6667C17.1624 29.1141 17.3819 28.5842 17.7726 28.1935C18.1633 27.8028 18.6932 27.5833 19.2458 27.5833Z"
              fill="url(#paint1_linear_54_4)"
            />
            <defs>
              <linearGradient
                id="paint0_linear_54_4"
                x1="2.28329"
                y1="9.875"
                x2="45.9333"
                y2="84.2958"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#0FAFFF" />
                <stop offset="1" stop-color="#CC23D1" />
              </linearGradient>
              <linearGradient
                id="paint1_linear_54_4"
                x1="18.6208"
                y1="19.4708"
                x2="20.1958"
                y2="33.0042"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#FDFDFD" />
                <stop offset="1" stop-color="#CCEAFF" />
              </linearGradient>
            </defs>
          </svg>
          <p class="text-xl font-medium mt-3">
            안녕하세요.<br />총회교육개발원 콘텐츠 몰 챗봇입니다.<br />무엇을
            도와드릴까요?
          </p>
          <p class="text-sm text-neutral-400 mt-2">{{ initialTime }}</p>
        </div>

        <!-- 질문 예시 grid - 입력이 없을 때만 표시 -->
        <div v-if="!hasUserInput" class="grid grid-cols-2 gap-3 my-5">
          <div class="w-full">
            <div
              class="w-full h-full border border-neutral-200 rounded-lg p-3 cursor-pointer hover:bg-gray-50 transition-colors"
              @click="handleQuestionClick('자주하는 질문 1')"
            >
              자주하는 질문
            </div>
          </div>
          <div class="w-full">
            <div
              class="w-full h-full border border-neutral-200 rounded-lg p-3 cursor-pointer hover:bg-gray-50 transition-colors"
              @click="handleQuestionClick('자주하는 질문 2')"
            >
              자주하는 질문
            </div>
          </div>
          <div class="w-full">
            <div
              class="w-full h-full border border-neutral-200 rounded-lg p-3 cursor-pointer hover:bg-gray-50 transition-colors"
              @click="handleQuestionClick('자주하는 질문 3')"
            >
              자주하는 질문
            </div>
          </div>
          <div class="w-full">
            <div
              class="w-full h-full border border-neutral-200 rounded-lg p-3 cursor-pointer hover:bg-gray-50 transition-colors"
              @click="handleQuestionClick('자주하는 질문 4')"
            >
              자주하는 질문
            </div>
          </div>
        </div>

        <!-- 질문 영역 - 입력이 있을 때만 표시 -->
        <div v-if="hasUserInput" class="my-5">
          <p
            class="w-[calc(100%-90px)] ml-auto mr-0 text-blue-700 bg-blue-50 rounded-lg p-4 break-words"
          >
            {{ userQuestion }}
          </p>
          <p class="text-sm text-neutral-400 mt-2">방금 전</p>
        </div>

        <!-- 답변 영역 - 답변이 있을 때만 표시 -->
        <div v-if="botAnswer" class="my-5">
          <div class="flex items-start gap-3">
            <div class="">
              <p
                class="w-[calc(100%-90px)] bg-neutral-100 rounded-lg p-4 break-words"
              >
                {{ botAnswer }}
              </p>
              <p class="text-sm text-neutral-400 mt-2">방금 전</p>
            </div>
          </div>
        </div>
      </div>

      <div class="sticky bottom-0 w-full bg-white p-5">
        <div
          class="w-full flex justify-between items-center gap-3 border border-neutral-200 rounded-lg px-4 py-3"
        >
          <input
            v-model="userInput"
            type="text"
            maxlength="500"
            placeholder="궁금한 사항을 입력해 주세요"
            class="w-full focus:outline-none"
            @keyup.enter="handleSendMessage"
          />
          <button @click="handleSendMessage" :disabled="!userInput.trim()">
            <svg
              width="31"
              height="31"
              viewBox="0 0 31 31"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              :class="{ 'opacity-50': !userInput.trim() }"
            >
              <path
                d="M17.476 17.8036L2.88058 22.1794L4.80064 15.7507L2.88058 9.32196L17.476 13.6978C19.5117 14.3085 19.5117 17.1907 17.476 17.8036Z"
                fill="url(#paint0_radial_55_8)"
              />
              <path
                d="M2.30201 0.863873C2.12265 0.774165 1.92171 0.736596 1.72205 0.755439C1.52239 0.774281 1.33203 0.84878 1.17262 0.97046C1.01321 1.09214 0.891145 1.25612 0.820317 1.44374C0.749488 1.63136 0.732737 1.83509 0.771969 2.03176L3.77848 12.4249C3.83454 12.6186 3.94411 12.7925 4.0946 12.9267C4.2451 13.0609 4.4304 13.1499 4.62921 13.1835L16.8224 15.2257C17.3967 15.3393 17.3967 16.1621 16.8224 16.2757L4.62921 18.3179C4.4304 18.3515 4.2451 18.4405 4.0946 18.5747C3.94411 18.7089 3.83454 18.8828 3.77848 19.0765L0.771969 29.4696C0.732737 29.6663 0.749488 29.87 0.820317 30.0577C0.891145 30.2453 1.01321 30.4093 1.17262 30.5309C1.33203 30.6526 1.52239 30.7271 1.72205 30.746C1.92171 30.7648 2.12265 30.7272 2.30201 30.6375L30.1599 16.7086C30.3376 16.6195 30.4871 16.4827 30.5915 16.3136C30.696 16.1444 30.7513 15.9495 30.7513 15.7507C30.7513 15.5519 30.696 15.357 30.5915 15.1878C30.4871 15.0187 30.3376 14.8819 30.1599 14.7928L2.30201 0.863873Z"
                fill="url(#paint1_linear_55_8)"
              />
              <path
                d="M2.30201 0.863873C2.12265 0.774165 1.92171 0.736596 1.72205 0.755439C1.52239 0.774281 1.33203 0.84878 1.17262 0.97046C1.01321 1.09214 0.891145 1.25612 0.820317 1.44374C0.749488 1.63136 0.732737 1.83509 0.771969 2.03176L3.77848 12.4249C3.83454 12.6186 3.94411 12.7925 4.0946 12.9267C4.2451 13.0609 4.4304 13.1499 4.62921 13.1835L16.8224 15.2257C17.3967 15.3393 17.3967 16.1621 16.8224 16.2757L4.62921 18.3179C4.4304 18.3515 4.2451 18.4405 4.0946 18.5747C3.94411 18.7089 3.83454 18.8828 3.77848 19.0765L0.771969 29.4696C0.732737 29.6663 0.749488 29.87 0.820317 30.0577C0.891145 30.2453 1.01321 30.4093 1.17262 30.5309C1.33203 30.6526 1.52239 30.7271 1.72205 30.746C1.92171 30.7648 2.12265 30.7272 2.30201 30.6375L30.1599 16.7086C30.3376 16.6195 30.4871 16.4827 30.5915 16.3136C30.696 16.1444 30.7513 15.9495 30.7513 15.7507C30.7513 15.5519 30.696 15.357 30.5915 15.1878C30.4871 15.0187 30.3376 14.8819 30.1599 14.7928L2.30201 0.863873Z"
                fill="url(#paint2_linear_55_8)"
              />
              <defs>
                <radialGradient
                  id="paint0_radial_55_8"
                  cx="0"
                  cy="0"
                  r="1"
                  gradientUnits="userSpaceOnUse"
                  gradientTransform="translate(-0.32093 15.7507) scale(15.9391 2.40776)"
                >
                  <stop stop-color="#0094F0" />
                  <stop offset="1" stop-color="#2052CB" />
                </radialGradient>
                <linearGradient
                  id="paint1_linear_55_8"
                  x1="0.75054"
                  y1="-11.4386"
                  x2="26.4441"
                  y2="22.7023"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#3BD5FF" />
                  <stop offset="1" stop-color="#0094F0" />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_55_8"
                  x1="15.7509"
                  y1="8.83551"
                  x2="23.5533"
                  y2="29.9454"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="0.125" stop-color="#DCF8FF" stop-opacity="0" />
                  <stop
                    offset="0.769"
                    stop-color="#FF6CE8"
                    stop-opacity="0.7"
                  />
                </linearGradient>
              </defs>
            </svg>
          </button>
        </div>
      </div>
    </div>
  </main>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";

// 반응형 데이터 정의
const userInput = ref("");
const userQuestion = ref("");
const botAnswer = ref("");
const initialTime = ref("");

// 오늘 날짜 계산 (YYYY. MM. DD (요일) 형식)
const todayDate = computed(() => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  const weekdays = ["일", "월", "화", "수", "목", "금", "토"];
  const weekday = weekdays[now.getDay()];

  return `${year}. ${month}. ${day} (${weekday})`;
});

// 컴포넌트가 마운트될 때 현재 시간 저장
onMounted(() => {
  const now = new Date();
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  initialTime.value = `${hours}:${minutes}`;
});

// 사용자 입력 여부를 계산하는 computed property - 전송된 경우에만 true
const hasUserInput = computed(() => {
  return userQuestion.value.trim().length > 0;
});

// 메시지 전송 함수
const handleSendMessage = () => {
  if (userInput.value.trim()) {
    userQuestion.value = userInput.value.trim();
    userInput.value = ""; // 입력 필드 초기화

    // 답변 시뮬레이션 (실제 API 호출 대신)
    setTimeout(() => {
      botAnswer.value = `"${userQuestion.value}"에 대해 구체적으로 어떤 도움이 필요하신가요?`;
    }, 1000);
  }
};

// 질문 예시 클릭 핸들러
const handleQuestionClick = (question) => {
  userQuestion.value = question;

  // 답변 시뮬레이션 (실제 API 호출 대신)
  setTimeout(() => {
    botAnswer.value = `"${question}"에 대해 구체적으로 어떤 도움이 필요하신가요?`;
  }, 1000);
};
</script>
